import { Typography } from "@mui/material"
import { createSlot } from "lib/@components/slot/create-slot"

export const HeaderButton = createSlot("HeaderButton")
export const SimilarityCheckboxHeader = createSlot("SimilarityCheckboxHeader")

const headerVariant = "subtitle1"
const flexibleColumnWidth = "calc((100% - 530px) / 2)"

export const similarityTableHeaders = [
    { title: <SimilarityCheckboxHeader.Slot />, sx: { width: 56, textAlign: "center" } },
    { title: <Typography variant={headerVariant}>Task Name</Typography>, sx: { width: flexibleColumnWidth } },
    { title: <Typography variant={headerVariant}>Schedule</Typography>, sx: { width: flexibleColumnWidth } },
    { title: <Typography variant={headerVariant}>Duration</Typography>, sx: { width: 100, textAlign: "center" } },
    { title: <Typography variant={headerVariant}>Frequency</Typography>, sx: { width: 100, textAlign: "center" } },
    { title: <Typography variant={headerVariant}>Skillset</Typography>, sx: { width: 80, textAlign: "center" } },
    { title: <Typography variant={headerVariant}>Match</Typography>, sx: { width: 150, textAlign: "center" } },
    { title: <HeaderButton.Slot />, sx: { width: 44 } },
]

export const similarityTableHeadersWithoutSelection = similarityTableHeaders.slice(1)
